const RightArrowIcon = ({
  size = 10, // controls height
  color = "#717182",
  strokeWidth = 1.333,
  isActive = false,
  activeColor = "#dc2626",
}) => {
  const strokeColor = isActive ? "#E7000B" : color;

  return (
    <svg
      width={(size * 6) / 10}
      height={size}
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666672 8.66669L4.66667 4.66669L0.666672 0.666687"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RightArrowIcon;
